import React from 'react';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import { lang, scssVariables as variables } from 'src/helpers';
import { getTruncatedText } from 'components/messages/chat/Message/TextItem';

export default class OriginalMessage extends React.PureComponent {
  render() {
    let { originalMessage, onClose, show } = this.props;
    const { text: displayText } = originalMessage?.text
      ? getTruncatedText(originalMessage.text)
      : { text: '', truncated: false };
    return (
      <div className={'mc-send-box-msg-edit mc-mb5 ' + (!show ? 'mc-hide' : '')}>
        <div className={'mc-mt10'}>
          <SVGIcon iconname={BASE_ICONS.EDIT} fill={variables['colors-mc-primary']} />
        </div>
        <div className={'mc-flex-5-col mc-grow'}>
          <div className={'mc-primary-520'}>{lang.t('Edit Message')}</div>
          {displayText}
        </div>
        <button type={'button'} className={'mc-no-style-btn'} onClick={onClose}>
          <SVGIcon iconname={BASE_ICONS.CLOSE} width={20} />
        </button>
      </div>
    );
  }
}
